import React from "react";

/* get the api url from iframe source */
export const get_api_urls = function () {
  var parsedHash = new URLSearchParams(
    window.location.hash.substr(1) // skip the first char (#)
  );
  var base_url = parsedHash.get("app_backend_url");
  var api_key = parsedHash.get("api_key");
  if (base_url == null) {
    console.warn(
      "No app_backend_url found in the url parameters. Falling back to app-test.onkopedia.com"
    );
    base_url = "https://app-test.onkopedia.com/";
  }
  if (api_key == null) {
    console.warn(
      "No app_key found in the url parameters. Falling back to the aapp-test.onkopedia.com"
    );
    api_key = "25c93545-699d-40d3-ab64-9c90d9484c27";
  }
  base_url = base_url.replace(/\/$/, "");

  return {
    api_url: base_url + "/structure/de/drug-assessment",
    api_vocabulary_url: base_url + "/vocabularies/de",
    api_key: api_key,
  };
};

/* Escape string for use in Javascript regex */
export const escapeRegExp = function (string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};
/* get_initial_drugs  */
export const get_initial_drugs = function () {
  var parsedHash = new URLSearchParams(
    window.location.hash.substr(1) // skip the first char (#)
  );

  var initial_drugs = parsedHash.get("initial_drugs");
  if (initial_drugs == null) {
    return [];
  }
  return initial_drugs.split(",");
};

export const get_site_url = function () {
  return new URLSearchParams(window.location.hash.substr(1)).get(
    "onkopedia_site_url"
  );
};

export const replace_site_url = (url) =>
  url.replace(/^\$onkopedia_url/, get_site_url());

export const get_user_role = function (el) {
  var parsedHash = new URLSearchParams(
    window.location.hash.substr(1) // skip the first char (#)
  );
  var mangerRole = parsedHash.get("userrole-manager");
  var href = parsedHash.get("href");

  if (mangerRole !== null) {
    return (
      <a className="admin" target="_PARENT" href={href + "#" + el.anchor}>
        [Link]
      </a>
    );
  }
  return false;
};
